import apiClient from "./apiClient";
import { ExportReportRequest, ReportColumn } from "../types/reports";

const EXPORT_TIMEOUT = 120000; // 120s for large exports

export const reportService = {
  getAvailableColumns: async (reportType: string): Promise<ReportColumn[]> => {
    const response = await apiClient.get(`/admin/reports/columns?reportType=${encodeURIComponent(reportType)}`);
    return response.data.data;
  },

  exportReport: async (request: ExportReportRequest): Promise<Blob> => {
    try {
      const response = await apiClient.post("/admin/reports/export", request, {
        responseType: "blob",
        timeout: EXPORT_TIMEOUT,
      });
      return response.data;
    } catch (error: unknown) {
      // When responseType is "blob", error responses are also returned as Blob.
      // Parse the blob back to JSON so formatApiError can read the error code.
      const axiosError = error as { response?: { data?: unknown } };
      if (axiosError?.response?.data instanceof Blob) {
        try {
          const text = await axiosError.response.data.text();
          const json = JSON.parse(text);
          axiosError.response.data = json;
        } catch {
          // If parsing fails, let the original error propagate
        }
      }
      throw error;
    }
  },

  estimateRowCount: async (request: ExportReportRequest): Promise<number> => {
    const response = await apiClient.post("/admin/reports/estimate", request);
    return response.data.data;
  },
};
